import { errorMapper } from '../mappers/error-mapper';
import { apiClient } from '../shared/api-client';

const authentificationRepository = {
    async requestToMagicLink(body) {
        try {
            const data = await apiClient.post({
                url: 'auth/email',
                body
            });

            return data;
        } catch (error) {
            throw errorMapper.toDomain(error);
        }
    },

    async signIn(token) {
        try {
            await apiClient.post({
                url: 'auth/email/sign-in',
                body: {},
                token
            });

            return true;
        } catch (error) {
            throw Error(error?.message || 'Sign in fail request');
        }
    },

    async signInBySubscription(subscriptionId) {
        try {
            await apiClient.post({
                url: 'auth/subscription',
                body: { subscriptionId }
            });

            return true;
        } catch (error) {
            throw Error(error?.message || 'Sign in by subscription fail request');
        }
    },

    async requestOtpByEmail(body) {
        try {
            const data = await apiClient.post({
                url: 'auth/email/otp',
                body
            });

            return data;
        } catch (error) {
            throw errorMapper.toDomain(error);
        }
    },

    async verifyOtp(body) {
        try {
            const data = await apiClient.post({
                url: 'auth/otp/validate',
                body
            });

            return data;
        } catch (error) {
            throw errorMapper.toDomain(error);
        }
    },

    async signOut() {
        try {
            await apiClient.post({
                url: 'auth/logout',
                body: {}
            });

            return true;
        } catch (error) {
            throw Error(error?.message || 'Sign out fail request');
        }
    }
};

export {
    authentificationRepository
};
